import React, { useContext, useMemo } from 'react';
import { ContextMenu } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const ActionsRenderer = ({
  rowData,
  rowData: { summarized, isThirdParty, slotId },
  columnData: { mappedEmployeesClientStatus, setBlockModal, onClickShift, enableBlockClients }
}) => {
  const { t } = useContext(ConfigContext);

  const shiftOptions = useMemo(() => {
    const employeeId = rowData?.employee?.id;
    if (!employeeId) {
      return;
    }

    const clientStatus = mappedEmployeesClientStatus?.[employeeId]?.status;

    const showBlockingEmployee = clientStatus !== 1 && !isThirdParty && enableBlockClients;

    const options = [
      { label: t('shiftDetails'), onClick: () => onClickShift(rowData) },
      {
        label: t('blockEmployee'),
        onClick: () => {
          setBlockModal({ employeeId, supplierSlotId: slotId, clientStatus: 1 });
        },
        visible: showBlockingEmployee
      }
    ];

    return options;
  }, [enableBlockClients, isThirdParty, mappedEmployeesClientStatus, onClickShift, rowData, setBlockModal, slotId, t]);

  if (summarized) {
    return <></>;
  }

  return <ContextMenu options={shiftOptions} usePortal />;
};

export default ActionsRenderer;
